import type { PortfolioFragmentType } from '@/hooks/portfolio/usePortfolio';

import { useCreateManualPortfolio } from '@/hooks/portfolio/useCreateManualPortfolio';
import { useAddHoldingsToManualPortfolio } from '@/hooks/portfolio/useAddHoldingsToManualPortfolio';

interface Props {
  onSuccess: (portfolio: PortfolioFragmentType) => void;
}

export const useCreateAddHoldings = ({ onSuccess }: Props) => {
  const {
    mutate: createNewPortfolio,
    status: createNewPortfolioMutationStatus,
  } = useCreateManualPortfolio({
    onSuccess(portfolio) {
      onSuccess(portfolio);
    },
  });

  const { mutate: addNewHoldings, status: addNewHoldingsMutationStatus } =
    useAddHoldingsToManualPortfolio({
      onSuccess(portfolio) {
        onSuccess(portfolio);
      },
    });

  return {
    createNewPortfolio,
    addNewHoldings,
    createNewPortfolioMutationStatus,
    addNewHoldingsMutationStatus,
  };
};
